import { Col, Row, useTheme } from "@commonlibs";
import clsx from "clsx";
import { useTranslate } from "ui/locale";
import { PasswordHint } from "./PasswordHint";
import { PassswordSecurityProgressBar } from "./PasswordTextFieldFooter.styles";
import { PasswordTextFieldFooterProps } from "./PasswordTextFieldFooter.types";

function PasswordTextFieldFooter({ className, progress, ...rest }: PasswordTextFieldFooterProps) {
    const translate = useTranslate();
    const { spacing } = useTheme();
    const gap = spacing[2];

    return (
        <Col className={clsx("password-text-field-footer", className)} gap={gap} {...rest}>
            <PassswordSecurityProgressBar value={progress} />
            <Row justifyContent="space-between">
                <PasswordHint>{translate("weak")}</PasswordHint>
                <PasswordHint>{translate("strong")}</PasswordHint>
            </Row>
        </Col>
    );
}

export default PasswordTextFieldFooter;
